export default ({ request }) => ({
  orderTechDocListApi(data = {}) {
    return request({
      url: '/factory/order/tech/doc/list',
      method: 'post',
      data,
    })
  },
  orderTechDocDetailApi(data = {}) {
    return request({
      url: '/factory/order/tech/doc/detail',
      method: 'post',
      data,
    })
  },
  orderTechDocBatchUploadApi(data = {}) {
    return request({
      url: '/factory/order/tech/doc/batchUpload',
      method: 'post',
      data,
    })
  },
  orderTechDocBatchDelApi(data = {}) {
    return request({
      url: '/factory/order/tech/doc/batchDel',
      method: 'post',
      data,
    })
  },
  orderTechDocUpdateApi(data = {}) {
    return request({
      url: '/factory/order/tech/doc/update',
      method: 'post',
      data,
    })
  },
  orderTechDocSpecListApi(data = {}) {
    return request({
      url: '/factory/order/tech/doc/spec/list',
      method: 'post',
      data,
    })
  },
  orderTechDocSpecBatchAddApi(data = {}) {
    return request({
      url: '/factory/order/tech/doc/spec/batchAdd',
      method: 'post',
      data,
    })
  },
  orderTechDocSpecBatchDelApi(data = {}) {
    return request({
      url: '/factory/order/tech/doc/spec/batchDel',
      method: 'post',
      data,
    })
  },
})
